<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Components
	import TimePickerWrapper from './TimePickerWrapper.svelte';
	//Services
	import { format } from '../../services/i18n';
	import { doubleTimePickerBreakpoint } from '../../helpers/constants';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	import TimePickerFormatWrapper from './TimePickerFormatWrapper.svelte';
	import type { ControlsContainerPropsTypes } from '@Shelly/shelly-design-system';
	let className = '';
	export { className as class };
	export let time = ['00:12', '03:12'];
	export let names = [$format('start_time'), $format('end_time')];
	export let orientation: ControlsContainerPropsTypes['orientation'] = null;

	let leftHours = Number(time[0].split(':')[0]);
	let leftMins = Number(time[0].split(':')[1]);
	let rightHours = Number(time[1].split(':')[0]);
	let rightMins = Number(time[1].split(':')[1]);

	let windowClientWidth: number;
	$: isMobile = windowClientWidth < doubleTimePickerBreakpoint;

	const dispatch = createEventDispatcher();

	const handle_change = (e, i) => {
		let hours = e.detail.hours.toString().padStart(2, '0');
		let mins = e.detail.formatedMins;

		time.splice(i, 1, `${hours}:${mins}`);
		dispatch('change', time);
	};
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<ControlsContainer
	class={className}
	orientation={orientation ? orientation : isMobile ? 'vertical' : 'horizontal'}
	color={$showNewLayout ? 'color-0' : undefined}
>
	<svelte:fragment slot="first">
		<TimePickerFormatWrapper
			bind:hours={leftHours}
			mins={leftMins}
			on:change={(e) => handle_change(e, 0)}
		/>
		<Text styleType="controls-large" class="mt-s text-bold">{names[0]}</Text>
	</svelte:fragment>
	<svelte:fragment slot="second">
		<TimePickerFormatWrapper
			bind:hours={rightHours}
			mins={rightMins}
			on:change={(e) => handle_change(e, 1)}
		/>
		<Text styleType="controls-large" class="mt-s text-bold">{names[1]}</Text>
	</svelte:fragment>
</ControlsContainer>
